import { paramCase } from 'src/utils/change-case';

import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figmaUrl: 'https://www.figma.com/design/cAPz4pYPtQEXivqe11EcDE/%5BPreview%5D-Minimal-Web.v6.0.0',
  settings: {
    root: `/settings`,
    checkout: `/settings/checkout`,
    details: (id) => `/settings/${id}`,
    demo: { details: `/settings/${MOCK_ID}` },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: { details: `/post/${paramCase(MOCK_TITLE)}` },
  },
  document: {
    root: `/document`,
    details: (title) => `/document/${title}`,
    demo: { details: `/document/${paramCase(MOCK_TITLE)}` },
  },
  projectOverview: {
    root: `/overview`,
    details: (title) => `/overview/${title}`,
    demo: { details: `/overview/${paramCase(MOCK_TITLE)}` },
  },
  // AUTH
  auth: {
    updatePassword: `${ROOTS.AUTH}/update-password`,

    // updatePassword: `${ROOTS.AUTH}/update-password`,
    // resetPassword: `${ROOTS.AUTH}/reset-password`,

    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      // updatePassword: `${ROOTS.AUTH}/update-password`,
      // resetPassword: `${ROOTS.AUTH}/reset-password`,
      // updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      // resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  authDemo: {
    split: {
      signIn: `${ROOTS.AUTH_DEMO}/split/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/split/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/split/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/split/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/split/verify`,
    },
    centered: {
      signIn: `${ROOTS.AUTH_DEMO}/centered/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/centered/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/centered/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/centered/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/centered/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,

    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,

    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
      course: `${ROOTS.DASHBOARD}/course`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      details: (id) => `${ROOTS.DASHBOARD}/user/${id}/details`,
      report: `${ROOTS.DASHBOARD}/user/report`,


      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    task: {
      new: `${ROOTS.DASHBOARD}/task/new`,
      newsubTask: (id) => `${ROOTS.DASHBOARD}/task/${id}/new-subtask`,
      root: `${ROOTS.DASHBOARD}/task`,
    },
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
      new: `${ROOTS.DASHBOARD}/settings/new`,
      details: (id) => `${ROOTS.DASHBOARD}/settings/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/settings/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/settings/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/settings/${MOCK_ID}/edit`,
      },
    },

    externalLink: {
      root: `${ROOTS.DASHBOARD}/externalLink`,
    },

    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${title}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    document : {
      root: `${ROOTS.DASHBOARD}/document`,
      new: `${ROOTS.DASHBOARD}/document/new`,
      details: (title) => `${ROOTS.DASHBOARD}/document/${title}`,
      edit: (title) => `${ROOTS.DASHBOARD}/document/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/document/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/document/${paramCase(MOCK_TITLE)}/edit`,
      },

    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      new: `${ROOTS.DASHBOARD}/order/new`,
      doc: `${ROOTS.DASHBOARD}/order/doc/new`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    loyalty: {
      root: `${ROOTS.DASHBOARD}/loyalty`,
      new: `${ROOTS.DASHBOARD}/loyalty/new`,
      details: (id) => `${ROOTS.DASHBOARD}/loyalty/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/loyalty/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/loyalty/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/loyalty/${MOCK_ID}/edit`,
      },
    },
    project: {
      root: `${ROOTS.DASHBOARD}/project`,
      new: `${ROOTS.DASHBOARD}/project/new`,
      details: (id) => `${ROOTS.DASHBOARD}/project/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/project/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/project/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/project/${MOCK_ID}/edit`,
      },
      newissue: `${ROOTS.DASHBOARD}/project/issues/new`,
    },
    vendor: {
      root: `${ROOTS.DASHBOARD}/vendor/list`,
      new: `${ROOTS.DASHBOARD}/vendor/new`,
      details: (id) => `${ROOTS.DASHBOARD}/vendor/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/vendor/${id}/edit`,
      addnewTask : (id) => `${ROOTS.DASHBOARD}/vendor/${id}/new-task`,
      details: (id) => `${ROOTS.DASHBOARD}/vendor/${id}/details`,
      newContract: `${ROOTS.DASHBOARD}/vendor/contract/new`,
      editContract: (id) => `${ROOTS.DASHBOARD}/vendor/contract/${id}/edit`,


    },
    timesheet: {
      root: `${ROOTS.DASHBOARD}/timesheet/list`,
      new: `${ROOTS.DASHBOARD}/timesheet/new`,
    },
    projectOverview: {
      root: `${ROOTS.DASHBOARD}/overview`,
      new: `${ROOTS.DASHBOARD}/overview/new`,
      details: (title) => `${ROOTS.DASHBOARD}/overview/${title}`,
      edit: (title) => `${ROOTS.DASHBOARD}/overview/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/overview/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/overview/${paramCase(MOCK_TITLE)}/edit`,
      },
    },

    client: {
      root: `${ROOTS.DASHBOARD}/client/list`,
      new: `${ROOTS.DASHBOARD}/client/new`,
      details: (id) => `${ROOTS.DASHBOARD}/client/${id}/details`,

      edit: (id) => `${ROOTS.DASHBOARD}/client/${id}/edit`,
      addnewTask : (id) => `${ROOTS.DASHBOARD}/client/${id}/new-task`,
      // details: (id) => `${ROOTS.DASHBOARD}/vendor/${id}/details`,
      newLead: `${ROOTS.DASHBOARD}/client/lead/new`,
      // editLead: `${ROOTS.DASHBOARD}/client/lead/${id}/edit`,
      editLead: (id) => `${ROOTS.DASHBOARD}/client/lead/${id}/edit`,

    },


  },
};
